"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAddressSearchResult = fetchAddressSearchResult;
var _globalApiClientReact = require("@ori/global-api-client-react");
var _models = require("../../models");
async function fetchAddressSearchResult(api, nodeId, country) {
  const emptyAddressResponse = {
    type: 'Area'
  };
  try {
    const addressNode = await (0, _globalApiClientReact.getAddressSearchResult)(api, nodeId, {
      country
    });
    return new _models.FetchResult(addressNode.status, addressNode.data);
  } catch (error) {
    return _models.FetchResult.errorFor(emptyAddressResponse);
  }
}
//# sourceMappingURL=fetchAddressSearchResult.js.map